module.exports = __webpack_public_path__ + "img/tbs-logo.197fc5fd.jpg";